import { render, staticRenderFns } from "./custom-form-import.vue?vue&type=template&id=1714d779&scoped=true&"
import script from "./custom-form-import.vue?vue&type=script&lang=js&"
export * from "./custom-form-import.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1714d779",
  null
  
)

export default component.exports